<template>
    <div class="card" data-testid="lab-results-page">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <b>Laboratorní výsledky</b>
                </div>
                <div class="col-md-6">
                </div>
            </div>
        </div>
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                    Filtrování
                </div>
                <div class="col-md-8 text-center">
                    <select v-model="assignedTo" class="mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" v-if="doctors.length > 0" data-testid="lab-results-doctor-filter">
                        <option :value="null">všichni doktoři</option>
                        <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                    </select>

                    <button class="btn btn-sm btn-outline-danger" value="accepted" v-if="selectedStates.indexOf('accepted') < 0" @click="selectedStates.push('accepted')" data-testid="lab-results-filter-accepted">nepřiřazené</button>
                    <button class="btn btn-sm btn-success" value="accepted" v-else="" @click="selectedStates.splice(selectedStates.indexOf('accepted'), 1)" data-testid="lab-results-filter-accepted">nepřiřazené</button>

                    <button class="btn btn-sm btn-outline-danger" value="assigned" v-if="selectedStates.indexOf('assigned') < 0" @click="selectedStates.push('assigned')" data-testid="lab-results-filter-assigned">nevyhodnocené</button>
                    <button class="btn btn-sm btn-success" value="assigned" v-else="" @click="selectedStates.splice(selectedStates.indexOf('assigned'), 1)" data-testid="lab-results-filter-assigned">nevyhodnocené</button>

                    <button class="btn btn-sm btn-outline-danger" value="wait_for_doctor" v-if="selectedStates.indexOf('wait_for_doctor') < 0" @click="selectedStates.push('wait_for_doctor')" data-testid="lab-results-filter-wait-for-doctor">předáno na doktora</button>
                    <button class="btn btn-sm btn-success" value="wait_for_doctor" v-else="" @click="selectedStates.splice(selectedStates.indexOf('wait_for_doctor'), 1)" data-testid="lab-results-filter-wait-for-doctor">předáno na doktora</button>

                    <!-- <button class="btn btn-sm btn-outline-danger" value="elaborated" v-if="selectedStates.indexOf('elaborated') < 0" @click="selectedStates.push('elaborated')">rozdělané</button>
                    <button class="btn btn-sm btn-success" value="elaborated" v-else="" @click="selectedStates.splice(selectedStates.indexOf('elaborated'), 1)">rozdělané</button> -->

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('completed') < 0" @click="selectedStates.push('completed')" data-testid="lab-results-filter-completed">dokončeno</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('completed'), 1)" data-testid="lab-results-filter-completed">dokončeno</button>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="getDoctorsDayTasks()" class="btn btn-secondary btn-sm" data-testid="lab-results-refresh"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="listData.length > 0">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1"></th>
                    <th class="col-sm-2">Stav</th>
                    <th class="col-sm-3">Klient</th>
                    <th class="col-sm-3">Doktor</th>
                    <th class="col-sm-3">Datum přijetí</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in listData" class="card-text">
                    <tr class="row m-0" :class="openedTaskId === task.id ? 'border border-primary border-bottom-0' : ''" :data-testid="'lab-results-row-' + task.id">
                        <td class="align-middle col-sm-1">
                            <button class="btn btn-sm btn-primary" @click="openTaskId(task.id, task)" v-if="openedTaskId === task.id" :data-testid="'lab-results-toggle-' + task.id">-</button>
                            <button class="btn btn-sm btn-secondary" @click="openTaskId(task.id, task)" v-else="" :data-testid="'lab-results-toggle-' + task.id">+</button>
                            <!-- <visit-change-state v-on:update="getDoctorsDayTasks" :actual-state="task.state" :selected-doctor-id="task.planned_for.id" :visit-id="task.id"></visit-change-state> -->
                        </td>
                        <td class="align-middle col-sm-2" :data-testid="'lab-results-state-' + task.id">
                            {{ task.state | taskStateToCS }}
                            <!--<router-link :to="{ name: 'ShowTask', params: { visitid: task.id }}">
                                {{ task.date }} od {{task.timeFrom}} do {{task.timeTo}} ({{ task.duration * 5 | minutesToCsTime }})
                            </router-link>-->
                        </td>
                        <td class="col-sm-3" :data-testid="'lab-results-client-' + task.id">
                            <template v-if="task.client">
                                <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: task.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link>
                                {{ task.client.full_name }}
                            </template>

                            <template v-else="">klient nepřiřazen</template>
                            <!--<router-link :to="{ name: 'ShowTask', params: { taskid: task.id }}">
                                <b>{{ task.visit_purpose.purpose }}</b>
                            </router-link>-->
                            <!--<template v-if="editingTaskId === task.id "><label for="note">poznámka: </label>
                                <form class="form-inline" @submit.prevent="putTask(visit)">
                                    <input v-model="editingTask.note" type="text" class="form-control ml-sm-1 mr-sm-2" aria-describedby="noteHelp" id="note">
                                    <button v-if="!waitForSave" type="submit" class="btn btn-primary">Uložit</button>
                                    <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                </form>
                            </template>
                            <template v-else=""><button @click="editTask(task.note, task.id)" class="btn btn-sm btn-link text-secondary"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ task.note }}</i></template>
                            -->
                        </td>
                        <td class="col-sm-3" :data-testid="'lab-results-doctor-' + task.id">
                            {{ task.assigned_to ? task.assigned_to.fullname : '' }}
                        </td>
                        <td class="col-sm-3" :data-testid="'lab-results-received-' + task.id">
                            {{ task.received_on }}
                        </td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0" v-if="openedTaskId === task.id" :data-testid="'lab-results-detail-' + task.id">
                        <td class="col-md-6">
                            <b>Laboratorní výsledek:</b><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" @click="copyResultText" v-html="task.result" :data-testid="'lab-results-content-' + task.id">

                            </div>
                        </td>
                        <td class="col-md-6">
                            <div>
                                <!--<form @submit.prevent="completeAndSubmit">-->
                                    <template v-if="task.client">
                                        <template v-if="task.state !== 'completed'">
                                            <div class="form-group">
                                                <label for="exampleFormControlTextarea1">Zpráva klientovi:</label>
                                                <br>
                                                <i>Dobrý den,</i>
                                                <textarea v-model="updatedTask.evaluation" class="form-control" id="exampleFormControlTextarea1" rows="10" :data-testid="'lab-results-evaluation-' + task.id"></textarea>
                                                <i>S pozdravem<br>
                                                    Urosanté</i>
                                            </div>
                                            <!-- <a v-if="task.client.email_address.length > 0" :href='"mailto:" + task.client.email_address[0].email + "?subject=Urosanté - Výsledek laboratorního vyšetření&body=" + openedTaskEvaluation' class="btn btn-primary">Odpovědět</a> -->
                                            <div>
                                                <label for="includeResultToMessage">Přidat laboratorní výsledek do zprávy</label>
                                                <input type="checkbox" id="includeResultToMessage" v-model="updatedTask.include_result_to_email" :data-testid="'lab-results-include-result-' + task.id">
                                            </div>
                                            <span class="text-danger" v-if="task.client.email_address.length < 1">Nelze odpovědět, klient nemá vyplněnou emailovou adresu.</span>
                                            <div class="row justify-content-between m-0">
                                                <div>
                                                    <button v-if="task.client.email_address.length > 0" @click="completeAndSubmit" class="btn btn-success" :data-testid="'lab-results-complete-email-' + task.id">Odpovědět a odsplnit</button>
                                                    <button @click="setWithoutEmail" class="btn btn-outline-success" :data-testid="'lab-results-complete-' + task.id">Pouze odsplnit</button>
                                                </div>

                                                <button class="btn btn-secondary" v-if="hasRole('doctor')" @click="showModalClientMedicament" :data-testid="'lab-results-prescription-' + task.id">Vypsat recept</button>
                                                <button v-if="task.state === 'assigned'" @click="handOverToDoctroAndSubmit" class="btn btn-warning" :data-testid="'lab-results-hand-off-' + task.id">Předat na doktora</button>
                                                <client-medicament :prop-client="task.client"/>
                                            </div>
                                        </template>
                                        <template v-else="">
                                            <div class="form-group">
                                                <label for="evaluationSent">Zpráva odeslaná klientovi:</label>
                                                <textarea v-model="updatedTask.evaluation" class="form-control" id="evaluationSent" rows="10" disabled="disabled"></textarea>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else="">
                                        <multiselect v-model="selected" :reset-after="false" id="search" label="label" track-by="code" placeholder="vyhledat klienta" open-direction="bottom" :options="clients" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" @search-change="getResult" @select="selectClient" :clear-on-select="true" selectLabel="" :data-testid="'lab-results-client-search-' + task.id"></multiselect>
                                        <button @click="assignAndSubmit" class="btn btn-success" v-if="selected" :data-testid="'lab-results-assign-' + task.id">Přiřadit klienta</button>
                                        <button class="btn btn-success disabled" v-else="" disabled="disabled">Přiřadit klienta</button>
                                    </template>
                                <!--</form>-->
                            </div>
                            <div>
                                <table class="table">
                                    <thead>
                                    <tr class="row m-0">
                                        <th class="col-sm-2">

                                        </th>
                                        <th class="col-sm-5">Datum odběru</th>
                                        <th class="col-sm-5"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                          <template v-for="(task, index) in tasks" class="card-text">
                                            <tr class="row m-0" :class="openedClientTaskId === index ? 'border border-primary border-bottom-0' : ''">
                                              <td class="align-middle col-sm-1">
                                                <button class="btn btn-sm btn-primary" @click="openClientTaskId(index, task)" v-if="openedClientTaskId === index">-</button>
                                                <button class="btn btn-sm btn-secondary" @click="openClientTaskId(index, task)" v-else="">+</button>
                                              </td>
                                              <td class="col-sm-3">{{ task.date_cs }}</td>
                                              <td class="col-sm-3">
                                                <span v-if="task.type === 'lab_result'"><i class="fa fa-flask fa-lg" aria-hidden="true"></i> Laboratorní výsledek</span>
                                                <span v-else=""><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Lékařská zpráva</span>
                                              <td class="col-sm-5"></td>
                                            </tr>
                                            <tr class="row m-0 border border-primary border-top-0" v-if="openedClientTaskId === index">
                                              <td class="col-md-12" v-if="task.type === 'lab_result'">
                                                <b>Laboratorní výsledek</b><br>
                                                <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.result">

                                                </div>
                                                <b>Hodnocení</b><br>
                                                <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.evaluation">

                                                </div>
                                              </td>
                                              <td class="col-md-12" v-else="">
                                                <b>Lékařská zpráva</b> <button class="btn btn-sm btn-primary" @click="copyAndInsertReport(task.text)">Zkopírovat</button><br>
                                                <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.text">

                                                </div>
                                                <template v-if="task.visit">
                                                  <div class="">
                                                    <h6>Diagnózy a výkony</h6>
                                                    <div>
                                                      <table class="table">
                                                        <tbody>
                                                        <template v-for="diagnose in task.visit.diagnosis">
                                                          <tr>
                                                            <td>{{ diagnose.disease.code }}</td>
                                                            <td>{{ diagnose.disease.name_cs }}</td>
                                                          </tr>
                                                          <template v-if="diagnose.actions.length > 0">
                                                            <template v-for="action in diagnose.actions">
                                                              <tr>
                                                                <td></td>
                                                                <td>
                                                                  {{ action.operation.code }} - {{ action.operation.name }}
                                                                </td>
                                                              </tr>
                                                              <template v-if="action.zulp.length > 0">
                                                                <tr v-for="zulp in action.zulp">
                                                                  <td></td>
                                                                  <td>
                                                                    &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                                  </td>
                                                                </tr>
                                                              </template>
                                                              <template v-if="action.zum.length > 0">
                                                                <tr v-for="zum in action.zum">
                                                                  <td></td>
                                                                  <td>
                                                                    &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                                  </td>
                                                                </tr>
                                                              </template>
                                                            </template>
                                                          </template>
                                                          <template v-else="">
                                                            <tr>
                                                              <td></td>
                                                              <td>
                                                                <i>(diagnóza nemá přidělené výkony)</i>
                                                              </td>
                                                            </tr>
                                                          </template>
                                                        </template>
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                  <div class="">
                                                    <h6>Léčiva</h6>
                                                    <div>
                                                      <template v-if="task.visit.medicament.length > 0">
                                                        <table class="table">
                                                          <tbody>
                                                          <tr v-for="m in task.visit.medicament">
                                                            <td>{{ m.medicine ? m.medicine.label : '' }} {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                            <td>{{ m.dosage }}</td>
                                                          </tr>
                                                          </tbody>
                                                        </table>
                                                      </template>
                                                      <template v-else="">
                                                        <i>žádný lék nepředepsán</i>
                                                      </template>
                                                    </div>
                                                  </div>
                                                </template>
                                              </td>
                                            </tr>

                                          </template>
                                    </tbody>
                                </table>
                            </div>

                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <pagination-component :list-pagination="listPagination" @set-page="setPage"/>
        </div>
        <div class="card-body" v-else-if="listPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="" data-testid="lab-results-empty">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (nebyl nalezen žádný výsledek dle požadavků)
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import ClientMedicament from '../../Modal/ClientMedicament'
  import PaginationComponent from '../../../components/PaginationComponent.vue'

  export default {
    data () {
      return {
        getParams: {
          p: 1,
          s: 'received_on-',
          f: {
          },
          pp: 20
        },
        selectedStates: [],
        print_date: '',
        assignedTo: '', // localStorage.getItem('userid'),
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        showClientMedicamentModal: false,
        selectedDate: '',
        listData: false,
        listError: false,
        listPagination: null,
        listPending: false,
        clientPreviousTasks: false,
        clientPreviousTasksError: false,
        clientPreviousTasksPending: true,
        waiting: true,
        editingTaskId: false,
        editingTask: {},
        waitForSave: false,
        openedTaskId: false,
        // subresults
        openedClientResults: false,
        openedTaskEvaluation: '',
        updatedTask: {
          evaluation: '',
          state: '',
          client_id: false,
          include_result_to_email: true,
          dont_send_email: false
        },
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        state: '',
        openedClientTaskId: false,
        //
        tasks: false,
        tasksError: false,
        tasksPending: true
      }
    },
    mixins: [apiMixin],
    methods: {
      setPage (number) {
        this.getParams.p = number
        this.getDoctorsDayTasks()
      },
      openTaskId (num, result) {
        if (this.openedTaskId === num) {
          this.openedTaskId = false
          this.openedTaskEvaluation = ''
          this.clientPreviousTasks = false
          this.clientPreviousTasksError = false
          this.clientPreviousTasksPending = true
        } else {
          this.openedTaskId = num
          if (result.client) {
            // console.log(result.client.id)
            // this.getClientPreviousResults(result.client.id, num)
            this.getMedicalReportAndLabResultOfClient(result.client.id, null)
          }
          // this.openedTaskEvaluation = result.evaluation
          this.updatedTask = {
            evaluation: result.evaluation,
            state: result.state,
            client_id: result.client_id,
            include_result_to_email: true
          }
        }
        // console.log(this.updatedTask)
      },
      openClientTaskId (num) {
        if (this.openedClientTaskId === num) {
          this.openedClientTaskId = false
        } else {
          this.openedClientTaskId = num
        }
        // console.log(this.updatedTask)
      },
      getClientPreviousResults (clientId, exceptResultId) {
        let getParams = {
          // date: moment(this.selected_date).format('DD.MM.YYYY'),
          // assigned_to: this.assignedTo,
          states: JSON.stringify(['completed']),
          client_id: clientId,
          except: exceptResultId
        }
        this.getClientPreviousTasks(getParams)
      },
      copyResultText () {
        let range = window.getSelection().getRangeAt(0)
        range.selectNode(document.getElementById('result_text'))
        window.getSelection().addRange(range)
        document.execCommand('copy')
      },
      countLinesTextResult (text) {
        return (text.split(/\r\n|\r|\n/).length) + 5
      },
      putTask () {
        this.waitForSave = true
        this.$http.put('result/' + this.openedTaskId, this.updatedTask, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.openedTaskId = false
          // this.editingTask = {}
          this.updatedTask.dont_send_email = false
          this.getDoctorsDayTasks()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      handOverToDoctroAndSubmit () {
        this.updatedTask.state = 'wait_for_doctor'
        this.putTask()
      },
      setWithoutEmail () {
        this.updatedTask.state = 'completed'
        this.updatedTask.dont_send_email = true
        this.putTask()
      },
      /* completeAndSubmitWithoutEmail () {
        this.updatedTask.dont_send_email = true
        this.completeAndSubmit()
      }, */
      completeAndSubmit () {
        this.updatedTask.state = 'completed'
        this.putTask()
      },
      assignAndSubmit () {
        this.putTask()
      },
      /* changeState (visitId, event) {
        this.$http.put('visit/' + visitId + '/change_state', {state: event.target.value}, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.waitForResponse = false
          this.getDoctorsDayTasks()
        }, response => {
          this.errors = response.data.errors
          this.waitForResponse = false
        })
      }, */
      getDoctorsDayTasks () {
        // let getParams = {
        //   assigned_to: this.assignedTo,
        //   states: JSON.stringify(this.selectedStates)}
        this.getResults(this.getParams)
      },
      selectToday () {
        this.selectedDate = this.$moment().toDate()
      },
      selectTomorrow () {
        this.selectedDate = this.$moment().add(1, 'days').toDate()
      },
      setDateAndLoad () {
        switch (this.selected_date.startOf('day').diff(this.$moment().startOf('day'), 'days')) {
          case 0:
            this.print_date = 'Dnes (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case 1:
            this.print_date = 'Zítra (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case -1:
            this.print_date = 'Včera (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          default:
            this.print_date = this.$moment(this.selected_date).format('dddd') + ' (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')'
        }
        this.getDoctorsDayTasks()
        this.waiting = false
      },
      showModalClientMedicament (selectedDoctorId) {
        this.selectedDoctorId = selectedDoctorId
        this.showModal('client-medicament')
      },
      showModal (name) {
        // console.log('zobrazuji modal')
        this.$modal.show(name)
      },
      selectClient (value) {
        // console.log('oteviram klienta' + value.id)
        this.updatedTask.client_id = value.id
        this.updatedTask.state = 'assigned'
      },
      getResult (text) {
        // loading(true)
        if (text.length > 2) {
          this.searchClients(text)
        }
      }
    },
    beforeMount () {
      this.getDoctors()
      if (this.userHasRole('doctor')) {
        this.waiting = true
        this.assignedTo = this.$ls.get('userid')
        this.selectedStates = ['wait_for_doctor']
        // this.selectedStates = JSON.parse(localStorage.getItem('home_states'))
        // this.selectedDate = moment(localStorage.getItem('home_date'), 'DD.MM.YYYY').toDate()
      } else {
        this.selectToday()
        localStorage.setItem('home_date', this.$moment().format('DD.MM.YYYY'))
        this.selectedStates = ['assigned', 'accepted']
      }
    },
    watch: {
      selectedStates: function (val) {
        this.getParams.f.state = val
        this.getDoctorsDayTasks()
      },
      assignedTo: function (val) {
        if (val === null) {
          delete this.getParams.f.assigned_to
        } else {
          this.getParams.f.assigned_to = val
        }

        this.getDoctorsDayTasks()
      },
      selectedDate: function (val) {
        localStorage.setItem('home_date', this.$moment(val).format('DD.MM.YYYY'))
        this.selected_date = this.$moment(val)
        this.setDateAndLoad()
      }
    },
    components: {
      PaginationComponent,
      // TaskChangeDoctor,
      // TaskChangeState,
      // Datepicker
      ClientMedicament
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Result/components/Results.vue?38d98f4c